/**
 * @generated SignedSource<<b53d902a40797790cf9d9b3f514c9063>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type StudentTargetFocusesFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  isActive: ActiveRecords;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
  targetIds?: ReadonlyArray<string> | null | undefined;
  userIds?: ReadonlyArray<string> | null | undefined;
};
export type StudentTargetFocusActiveQuery$variables = {
  filter?: StudentTargetFocusesFilterInput | null | undefined;
};
export type StudentTargetFocusActiveQuery$data = {
  readonly studentTargetFocuses: ReadonlyArray<{
    readonly focusSeenOn: any | null | undefined;
    readonly id: string;
    readonly isActive: boolean;
    readonly otherTargetsBlocked: boolean;
    readonly target: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly summary: string | null | undefined;
    } | null | undefined;
  }>;
};
export type StudentTargetFocusActiveQuery = {
  response: StudentTargetFocusActiveQuery$data;
  variables: StudentTargetFocusActiveQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "studentTargetFocusesFilterInput",
        "variableName": "filter"
      }
    ],
    "concreteType": "StudentTargetFocusNode",
    "kind": "LinkedField",
    "name": "studentTargetFocuses",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "focusSeenOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otherTargetsBlocked",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TargetNode",
        "kind": "LinkedField",
        "name": "target",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "summary",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StudentTargetFocusActiveQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StudentTargetFocusActiveQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "84545cc9310351cf9d1876e77a09f42c",
    "id": null,
    "metadata": {},
    "name": "StudentTargetFocusActiveQuery",
    "operationKind": "query",
    "text": "query StudentTargetFocusActiveQuery(\n  $filter: StudentTargetFocusesFilterInput\n) {\n  studentTargetFocuses(studentTargetFocusesFilterInput: $filter) {\n    id\n    isActive\n    focusSeenOn\n    otherTargetsBlocked\n    target {\n      id\n      name\n      summary\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8e16f1ad5afd1d4586931402b9731620";

export default node;
